<template>
  <div class="container_Search">
    <div class="left">
      <svg
        t="1574755620026"
        class="icon icon_search"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="11485"
        width="26"
        height="22"
      >
        <path
          d="M900.266667 900.266667c-8.533333 8.533333-21.333333 8.533333-29.866667 0L740.266667 768c-66.133333 59.733333-153.6 96-249.6 96-206.933333 0-373.333333-166.4-373.333333-373.333333S283.733333 119.466667 490.666667 119.466667s373.333333 166.4 373.333333 373.333333c0 93.866667-36.266667 181.333333-93.866667 245.333333l130.133333 130.133333C908.8 876.8 908.8 891.733333 900.266667 900.266667zM490.666667 162.133333c-183.466667 0-330.666667 147.2-330.666667 330.666667S307.2 823.466667 490.666667 823.466667s330.666667-147.2 330.666667-330.666667S672 162.133333 490.666667 162.133333z"
          p-id="11486"
          fill="#8a8a8a"
        />
      </svg>
      <input type="text" v-model="search_ipt" class="search_ipt" placeholder="搜索内容..." />
    </div>
    <div class="right">
      <button>搜索</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search_ipt: null
    }
  },
  props: {
    prop: {
      type: String,
      required: false
    }
  },
  components: {},
  computed: {},
  watch: {
    search_ipt(newVal, oldVal) {
      this.$emit('watchItp', newVal)
    }
  },
  methods: {
    // type your function
  },
  created() {},
  mounted() {},
  updated() {},
  destroyed() {},
  filters: {}
}
</script>

<style scoped lang="less">
@import '../../common/Less/index';
.container_Search {
  .mixin_flex_ct();
  .mixin_wh(630px, 40px);
  position: relative;
  justify-content: space-between;
  border: 2px solid @blue;
  border-radius: 20px;
  margin: 0 auto;

  .left {
    .mixin_flex_ct();
    justify-content: left;
    flex: 1;
    .icon_search {
      margin: 8px 0 10px 26px;
    }
    .search_ipt {
      .mixin_wh(50%, 14px);

      border: none;
      outline: none;
      font-size: @fontSize - 2;
      font-weight: 400;
      margin-left: 25px;
      letter-spacing: 3px;
    }
  }
  .right {
    > button {
      .mixin_absolute(0, -3px, '', '');
      .mixin_wh(116px, 36px);
      .mixin_cb(@white, @blue);
      border: none;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/Search.vue